export default { 
  PRODUCT_ADDED_TO_CART: ":productName: added to cart successfully.",
  PRODUCT_ADDED_TO_WISHLIST: ":productName: successfully added to your wishlist.",
};
